import { BASE_ENDPOINT } from "../../endpoint";

export const remitPayrollService = async (TOKEN, companyId, payrollId) => {
    try {
        const response = await fetch(`${BASE_ENDPOINT}/api/payrolls/${payrollId}/company/${companyId}/remit`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${TOKEN}`,
                'Content-Type': 'application/json',
            },
        });
        const res = await response.json();
        if (!response.ok) {
            console.error('Error:', res);
            throw new Error(res.message);
        }
        return res;
    } catch (error) {
        console.error('API fetch error:', error);
        throw error;
    }
};